import React from 'react';

const Advertisement = () => {
    return (
        <div>
             <div className="container">
      <h1>Advertisement Pricing</h1> <br/>
      <p>Below is the pricing for advertising on our platform:</p> <br/> <br/>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Duration</th>
              <th>Amount (Rs)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1 Day</td>
              <td>100</td>
            </tr>
            <tr>
              <td>2 Days</td>
              <td>200</td>
            </tr>
            <tr>
              <td>3 Days</td>
              <td>300</td>
            </tr>
            {/* Add more rows as needed */}
          </tbody>
        </table>
      </div>
      <br/> <br/> <br/> <br/>
      <p>
        Contact us through <a href="mailto:quicklearnrtu@gmail.com">email</a> for advertisement
      </p>
    </div>
        </div>
    );
}

export default Advertisement;
